export const getSsnCreatedAt = (ssnData?: Record<string, any> | null) =>
  ssnData?.createdon ??
  ssnData?.created_on ??
  ssnData?.CreatedOn ??
  ssnData?.file_created_on ??
  null;
